export const SET_ORDERS = 'SET_ORDERS';
export const SET_WAYBILLS = 'SET_WAYBILLS';
export const SET_SIGN_CONFIRMS = 'SET_SIGN_CONFIRMS';
export const SET_SIGN_LIST = 'SET_SIGN_LIST';
export const SET_FINANCE_WAYBILLS = 'SET_FINANCE_WAYBILLS';
export const SET_TRANSCATIONS = 'SET_TRANSCATIONS';
export const SET_ADDITIONAL_STATUSES = 'SET_ADDITIONAL_STATUSES';
export const SET_WAYBILL_LOGS = 'SET_WAYBILL_LOGS';
